import React, { Fragment } from 'react';
import '../../../App.css';
import { useAppSelector } from '../../../store/hooks';
import { RootState } from "../../../store/store";

const Statusbar = () => {

  const mousePosition = useAppSelector((state: RootState) => state.interface.mouseUnmodifiedPosition)
  const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
  const toolMessage = useAppSelector((state: RootState) => state.interaction.toolMessage)
  const definitonInputbar = useAppSelector((state: RootState) => state.interaction.numberInput)

  //Todo make it a proper list instead of this same level divs for each value
  const statusbarItem = [];
  statusbarItem.push({ string: "x:", value: mousePosition.x.toFixed(2) })
  statusbarItem.push({ string: "y:", value: mousePosition.y.toFixed(2) })
  statusbarItem.push({ string: "scale:", value: scale.toFixed(2) })

  return (
    <>
      {statusbarItem.map(
        (item) => {
          return (
            <Fragment key={item.string}>
              <div className='statusbar--list-item'>{item.string}</div>
              <div className='statusbar--list-value'>{item.value}</div>
            </Fragment>
          )
        }
      )}
      <div className='statusbar--list-item'>{toolMessage}</div>
      <div className='statusbar--list-item'>{"x: " + definitonInputbar.distance.x}</div>
      <div className='statusbar--list-item'>{"y: " + definitonInputbar.distance.y}</div>
    </>
  )
};

export default Statusbar;